












import { Component, Prop, Vue , Watch } from "vue-property-decorator";

import * as def from '@/definitions'
// TODO document2
import { Document } from '@/model/document2/document'

import { UuidHelper } from '@/helper/uuidHelper';
import RecommendBanner from "@/components/recommend/RecommendBanner.vue";
import RecommendBannerProps from "@/components/recommend/RecommendBannerProps";

@Component({
  components: {
      RecommendBanner
  },
})
export default class RightControllerInsertion extends Vue {
    @Prop() private document! : Document
    @Prop({ default: () => [] }) banners!: RecommendBannerProps[];

    private onDoCommand(command : string, paramater : any)
    {
        this.$emit("doCommand", command, paramater);
    }

    private onClickCreateDesign()
    {
        this.onDoCommand("createDesign", null);
    }

    private onClickSaveDocument()
    {
        this.onDoCommand("saveDocument", null);
    }

    private onClickGoNext()
    {
        this.onDoCommand("goNext", null);
    }

    private onClickLoadDocument()
    {
        this.onDoCommand("loadDocument", null);
    }

    private get userConfigbackgroundColor(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }

    //------読み込んだドキュメントが持つデザイン一覧-----//
    private get desingViewItems()
    {
        var items = new Array();
        var designMaterials = this.$store.getters.userConfig.designMaterials;
        for(var i = 0; i < designMaterials.length; ++i)
        {
            var design = designMaterials[i];
            items.push({
                design : design,
                index: i,
                id : UuidHelper.getUuid()
            });
        }
        return items;
    }

    private onDragDesignStart(index : number)
    {
        this.onDoCommand("startDragMaterial", { index : index });
    }

    private onDragDesignEnd()
    {
        this.onDoCommand("endDragMaterial", null);
    }


    clickBanner(banner: RecommendBannerProps) {
        this.$emit("click-banner", banner.key);
    }
}
